import styled from 'styled-components'

export const StyledRootContainer = styled.div`
  display: flex;
`;

export const StyledMainContainer = styled.main`
  min-height: 100vh;
  width: 100%;
  padding: ${({auth}) => auth ? '125px 25px 25px' : '15px'};
  background-color: #F5F4FA;
  flex-grow: 1;
  position: relative;
  overflow-x: hidden;
  @media screen and (max-width: 992px) {
    padding: ${({auth}) => auth ? '125px 20px 20px 91px' : '15px'};
  }
  @media screen and (max-width: 599px) {
    padding: ${({auth}) => auth ? '80px 15px 15px 15px' : '15px'};
  }
`;

export const StyledContentWrapper = styled.div`
  min-height: ${({height}) => height === 'auto' ? 'auto' : 'calc(100vh - 150px)'};
  padding: 20px;
  background-color: #fff;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  box-shadow: 0 2px 4px #C4C4C4;
  @media screen and (max-width: 599px) {
    padding: 20px 15px;
  }
`;
